import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex justify-between w-full py-3 px-7" }

import ScorecardSection from './ScorecardSection.vue';
import { PropType, ref, toRefs } from 'vue';
import ToggleButtons from '../Inputs/ToggleButtons.vue';
import { useScorecardStore } from '@/store/scorecards';
import PotentialScore from './PotentialScore.vue';
import { ScorecardDisplayState } from '@/typings/scorecard';


export default /*#__PURE__*/_defineComponent({
  props: {
  briefcases: {
    type: Array as PropType<Array<string>>,
    required: true,
  },
  response: {
    type: Array as PropType<Array<string>>,
    required: true,
  },
  correctResponse: {
    type: Array as PropType<Array<string>>,
    required: true,
  },
  disabled: {
    type: Boolean,
  },
},
  setup(__props) {

const props = __props

const store = useScorecardStore();

const { scorecard } = toRefs(store);

const items = ref([
  { text: 'No Attempt', value: '0', clickable: true },
  { text: 'Attempted Cash In', value: '1', clickable: true },
  { text: 'Cashed In', value: '2', clickable: true },
]);



const { response, correctResponse } = toRefs(props);
const scorecardStore = useScorecardStore();

const answer = ref(response?.value || []);

function score(index: number) {
  if (scorecardStore.displayState === ScorecardDisplayState.View) {
    if (response.value && correctResponse.value) {
      if (
        response.value[index].toString() ===
        correctResponse.value[index].toString()
      ) {
        return `+${scorecard?.value?.event.BriefcasePointValue}`;
      }
      return '+0';
    }
    return '';
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ScorecardSection, { title: "Briefcase Cash In" }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.briefcases, (briefcase, index) => {
        return (_openBlock(), _createElementBlock("div", { key: briefcase }, [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(ToggleButtons, {
              title: briefcase,
              items: items.value,
              disabled: __props.disabled,
              modelValue: answer.value[index],
              "onUpdate:modelValue": ($event: any) => ((answer.value[index]) = $event),
              status: score(index)
            }, null, 8, ["title", "items", "disabled", "modelValue", "onUpdate:modelValue", "status"])
          ])
        ]))
      }), 128)),
      (_unref(scorecard))
        ? (_openBlock(), _createBlock(PotentialScore, {
            key: 0,
            score: _unref(scorecard).event.BriefcasePointValue * __props.briefcases.length
          }, null, 8, ["score"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})